module.exports = __webpack_public_path__ + "static/media/mz.0b0814e8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mz.svg
// module id = 2169
// module chunks = 0